var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-2 ml-md-5 ml-sm-2 mr-4 pb-3" },
    [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        !_vm.hideFilter
          ? _c(
              "div",
              { staticClass: "col col-sm col-12 text-right" },
              [
                _c("drop-down", {
                  attrs: {
                    items: _vm.filterOptions,
                    title: _vm.filterTitle(_vm.selectedFilter),
                    variant: "rounded-dark"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.items.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c(
        "time-line",
        { staticClass: "mt-4" },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            { key: `item-index-${index}` },
            [
              _c(
                "time-line-item",
                {
                  staticClass: "custom-time-line rounded",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function() {
                          return [
                            _c("em", {
                              staticClass: "radius",
                              class: `fas fa-${item.eventTypeIcon}`,
                              style: { color: item.eventTypeIconColor }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "date",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "date-container" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold fulldate"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("date")(item.eventDate)) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-12 font-weight-normal hour"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("hour")(item.eventDate)) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  !_vm.isFinding(item.eventTypeId)
                    ? _c(
                        "div",
                        { staticClass: "row", attrs: { id: "main-info" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-sm-2 gradient-border text-md-center text-sm-left p-3 order-2 order-md-0 order-sm-2 ml-4 ml-md-0 ml-sm-4 mt-n3 mt-md-0 mt-sm-n3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 ml-n5 d-sm-none d-md-block font-weight-normal"
                                },
                                [_vm._v(" Estatus: ")]
                              ),
                              _c("em", {
                                staticClass: "fa fa-circle font-12 mr-2",
                                class: `color-${_vm.getColor(
                                  item.eventTypeId ==
                                    _vm.eventTypesEnum.CambioDeEstatus
                                    ? item.statusNewId
                                    : item.statusId
                                )}`
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold text-status"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.eventTypeId ==
                                          _vm.eventTypesEnum.CambioDeEstatus
                                          ? item.statusNewName
                                          : item.statusName
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-9 p-3 pl-4 d-flex align-items-center pr-0"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-secondary-33 font-16 text-description font-weight-normal"
                                },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$options.filters.bold(
                                          item.eventDescription
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 my-2 border-left d-flex justify-content-center align-items-center toggle-action",
                              on: {
                                click: function($event) {
                                  return _vm.onToggle(index, item)
                                }
                              }
                            },
                            [
                              _c("em", {
                                staticClass: "font-18 cursor-pointer",
                                class: _vm.toggleClass(
                                  item.isOpen,
                                  item.eventTypeId
                                )
                              })
                            ]
                          )
                        ]
                      )
                    : _c("div", { staticClass: "row py-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-11 p-3 pl-4 d-flex align-items-center pr-0"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-33 font-16 text-description font-weight-normal ml-4"
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$options.filters.bold(
                                        item.eventDescription
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 my-2 border-left d-flex justify-content-center align-items-center toggle-action",
                            on: {
                              click: function($event) {
                                return _vm.onToggle(index, item)
                              }
                            }
                          },
                          [
                            _c("em", {
                              staticClass: "font-18 cursor-pointer",
                              class: _vm.toggleClass(
                                item.isOpen,
                                item.eventTypeId
                              )
                            })
                          ]
                        )
                      ]),
                  item.isOpen
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row bg-white mx-3 px-0 px-md-3 px-sm-0 py-0 py-md-4 py-sm-0 pb-3 rounded additional-panel"
                        },
                        [
                          _vm.showJournalNumber(item.eventTypeId)
                            ? _c("div", { staticClass: "col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-gray-6 font-14 font-weight-normal label-text"
                                  },
                                  [_vm._v(" Número de Jornal: ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-black font-16 font-weight-bold label-value"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.details.journalNumber) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm.showCompliancePayroll(item.eventTypeId)
                            ? _c(
                                "div",
                                { staticClass: "col mt-4 mt-md-0 mt-sm-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Cumplimiento de Pago: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "badge badge-pill badge-primary p-2 bg-secondary-32"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-14 font-weight-bold mx-2 label-value"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.details.compliancePayment
                                                  ? item.details
                                                      .compliancePayment +
                                                      " días "
                                                  : "-"
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showPayrollDate(item.eventTypeId)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Fecha de Nómina: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("date")(
                                              item.details.payrollDate
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showReceiveDate(item.eventTypeId)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Fecha de Recibido: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("date")(
                                              item.details.receiveDate
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showReceiveTypeName(item.eventTypeId)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Recibido: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.details.receiveTypeName || "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showAssistanceCount(item.eventTypeId)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Asistencias: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.details.assistanceCount) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showDenialReason(
                            item.eventTypeId ==
                              _vm.eventTypesEnum.CambioDeEstatus
                              ? item.statusNewId
                              : item.statusId,
                            item.eventTypeId
                          )
                            ? _c(
                                "div",
                                { staticClass: "col mt-2 mt-md-0 mt-sm-12" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Razón: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.details.reasonName) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showManualAdjustmentReason(item.eventTypeId)
                            ? _c(
                                "div",
                                { staticClass: "col mt-2 mt-md-0 mt-sm-12" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Razón: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.details.manualAdjustmentReason
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showDenialReason(
                            item.eventTypeId ==
                              _vm.eventTypesEnum.CambioDeEstatus
                              ? item.statusNewId
                              : item.statusId,
                            item.eventTypeId
                          )
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-sm col-12 mt-2 mt-md-0 mt-sm-12"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Comentario: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.details.reasonComment) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showComment(item.eventTypeId)
                            ? _c(
                                "div",
                                { staticClass: "col mt-4 mt-md-0 mt-sm-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Comentario: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.details.addtionalPaymentComent
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showManualAdjustmentComment(item.eventTypeId)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-sm col-12 mt-2 mt-md-0 mt-sm-0"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Comentario: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.details.manualAdjustmentComment
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showUser(item.eventTypeId)
                            ? _c(
                                "div",
                                { staticClass: "col mt-2 mt-md-0 mt-sm-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal label-text"
                                    },
                                    [_vm._v(" Usuario: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold label-value"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.details.user) + " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showFollowUp(item.eventTypeId)
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-gray-6 font-14 font-weight-normal label-text"
                                        },
                                        [_vm._v(" Categoría: ")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-black font-16 font-weight-bold label-value"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.details
                                                  .followUpCategoryName
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-gray-6 font-14 font-weight-normal label-text"
                                        },
                                        [_vm._v(" Usuario: ")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-black font-16 font-weight-bold label-value"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.details.user) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "row mt-2 mt-md-4 mt-sm-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col mt-4 mt-md-0 mt-sm-4"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-gray-6 font-14 font-weight-normal label-text"
                                          },
                                          [_vm._v(" Comentario: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-bold label-value"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.details.followUpComment
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  item.isOpen ? _c("br") : _vm._e()
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col col-sm col-12 pt-2" }, [
      _c("em", { staticClass: "fas fa-file-search text-orange mr-1" }),
      _c("span", { staticClass: "color-gray-7 font-16 font-weight-bold" }, [
        _vm._v(" Historial ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }